module.exports = __webpack_public_path__ + "img/1555204053.80ec91c2.jpg";